import { Button } from "@material-ui/core";
import React from "react";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { ReactComponent as WhatsApp } from "./assets/whatsapp.svg";
import { ReactComponent as Success } from "./assets/complete.svg";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function BenefitTransfer({ order, language, themeColor ,whatsappOption}) {
  const [open, setOpen] = React.useState(false);
  if (order.payment_complete === true) {
    return (
      <div
        className="border w-100 row mb-4"
        style={{
          backgroundColor: "white",
          minHeight: 70,
          margin: 0,
          alignItems: "center",
        }}
      >
        <div
          className="col-3"
          style={{ textAlign: language == "arabic" ? "left" : "right" }}
        >
          <Success style={{ width: 40, height: 40 }} />
        </div>
        <div
          className="col-9 bold"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language == "english"
            ? "Your payment has been approved"
            : "تم قبول عملية الدفع"}
        </div>
      </div>
    );
  }

  const copyToClipboard = () => {
    const textField = document.createElement("textarea");
    textField.innerText = order.iban;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const whatsappText =
    language == "english"
      ? `Hello. I'm sending this message to verify my order ${order.tracking_id} by sending you a screenshot of the payment`
      : `${order.tracking_id} مرحبا. اود ان اثبت عملية دفع لطلب وسأقوم بإرسال صورة لتأكيد تحويل الايبان. رقم تتبع الطلب هو`;

  return (
    <div
      className="border w-100 row mb-4"
      style={{ backgroundColor: "white", minHeight: 70, margin: 0 }}
    >
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={handleClose} severity="success">
          <span className="mx-3">
            {language == "english"
              ? "IBAN copied successfully!"
              : "تم نسخ الايبان"}
          </span>
        </Alert>
      </Snackbar>
      <div
        className={"col-12 py-3 ".concat(
          language == "english" ? "text-left" : "text-right"
        )}
      >
        <p className="bold">
          {language == "english"
            ? "To complete the payment:"
            : "لاتمام عملية الدفع:"}
        </p>
        <ol style={{ paddingLeft: 25, marginBottom: 5 }}>
          <li>
            <p className="mt-4">
              {language == "english"
                ? "Transfer to this IBAN"
                : "قم بالتحويل الى هذا الايبان"}
            </p>

            <p className="mb-1 bold text-center mt-3">{order.iban}</p>
            <div className="text-center">
              <Button
                variant="contained"
                className="mt-2"
                color="primary"
                disableElevation
                onClick={() => {
                  copyToClipboard();
                  setOpen(true);
                }}
              >
                <AssignmentIcon
                  style={{
                    width: 25,
                    height: 25,
                    marginRight: language == "english" && 10,
                    marginLeft: language == "arabic" && 10,
                  }}
                />{" "}
                {language == "english" ? "Copy" : "نسخ"}
              </Button>
            </div>
          </li>

          {whatsappOption &&
            <li>
              <p className="mb-1 mt-4">
                {language == "english"
                  ? "Send us a screenshot here"
                  : "قم بارسال صورة اثبات الدفع هنا"}
              </p>
              <div className="text-center" style={{ marginTop: 16 }}>
                <a
                  href={encodeURI(
                    `https://wa.me/${order.benefit_transfer_whatsapp_number}?text=${whatsappText}`
                  )}
                  target="_blank"
                  style={{ color: "white" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#25D366",
                      margin: "auto",
                      color: "white",
                      padding: "10px 25px",
                    }}
                  >
                    <WhatsApp
                      style={{
                        width: 25,
                        height: 25,
                        marginRight: language == "english" && 10,
                        marginLeft: language == "arabic" && 10,
                      }}
                    />{" "}
                    {language == "english" ? "WhatsApp" : "واتساب"}
                  </Button>{" "}
                </a>
              </div>
            </li>
          }
        </ol>
      </div>
    </div>
  );
}
